module.exports = __webpack_public_path__ + "assets/travel.jpg?c09b085692c07e0cb1a7cafb5765f37d";